export const REVIEWS_MODULE_CREATIVE_ID = 'offer-details-reviews';

export const REVIEWS_MODULE_USER_REVIEW_CONTENT_PATH = 'editorial/includes/offers/user-reviews';
